import { render, staticRenderFns } from "./CreateTicketTask.vue?vue&type=template&id=b5253368"
import script from "./CreateTicketTask.vue?vue&type=script&lang=js"
export * from "./CreateTicketTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports